export default __webpack_public_path__ + "images/4c79ee5fce6a0e899dbeda24b2a3751b.png";